import { Link } from 'react-router';
import { Trans } from '@ui/i18n/trans';
import { Button } from '@ui/buttons/button';

export function NotFoundPage() {
    return (
        <div className="min-h-screen bg-black flex items-center justify-center p-8 relative overflow-hidden">
            {/* Large 404 in background */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
                <span className="text-[20rem] md:text-[30rem] font-black text-zinc-900/50 tracking-tighter">
                    404
                </span>
            </div>

            {/* Content */}
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 max-w-5xl w-full">
                {/* Left side - Text */}
                <div className="flex-1 text-center md:text-left">
                    <h1 className="text-2xl md:text-3xl font-bold text-white mb-4">
                        <Trans message="Looks like you've found the doorway to the great nothing" />
                    </h1>
                    <p className="text-zinc-400 mb-8">
                        <Trans message="Sorry about that! Please visit our homepage to get where you need to go." />
                    </p>
                    <Button
                        variant="flat"
                        color="primary"
                        elementType={Link}
                        to="/"
                        size="md"
                    >
                        <Trans message="Take me there!" />
                    </Button>
                </div>

                {/* Right side - Illustration */}
                <div className="flex-1 flex justify-center">
                    <img
                        src="/images/404-illustration.svg"
                        alt="404 Illustration"
                        className="w-64 h-64 md:w-80 md:h-80 object-contain"
                        onError={(e) => {
                            // Hide if image not found
                            (e.target as HTMLImageElement).style.display = 'none';
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
